// extracted by mini-css-extract-plugin
module.exports =  {"root":"s4lRYDoRj4vUTFQJsIPn","square":"Rw3DigZ7L6WF4LTeg6Cg","rounded":"uNNFQ9Oz26ys6miSJbzb","pill":"TW8LoUuwY7XslF7p1PBv","active":"yeHIIbLcKmZjCdc5DzEi"};